export default "__VITE_ASSET__D_Bk4wGR__"